// extracted by mini-css-extract-plugin
export default {"wrapper":"LuckyBagComponent_wrapper__SfcYl","title":"LuckyBagComponent_title__WgRPM","detailItem":"LuckyBagComponent_detailItem__C0o4q","label":"LuckyBagComponent_label__YHq9a"};